import styled from "styled-components";

export const AboutSection = styled.section`
  padding: 50px 20px;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
     margin-top: 150px;
  }


  article {
    display: flex;
    gap: 40px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
    }

    img {
      width: 50%;
      height: 600px;
      object-fit: cover;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
      }
    }
    .about_content {
      width: 50%;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
      }
      h5 {
        color: ${({ theme }) => theme.color.red};
      }
      h2 {
        margin-bottom: 20px;
        color: ${({ theme }) => theme.color.blackText};
      }
      p {
        font-weight: 500;
        font-size: 0.9rem;
        line-height: 1.7;
        opacity: 0.5;
      }

      section {
        width: 100%;
        margin-top: 20px;
        menu {
          padding: 0;
          display: flex;
          gap: 20px;
          justify-content: center;
          align-items: center;
          li {
            list-style: none;
            text-align: center;
            width: 100%;
            button {
              box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
              border-radius: 5px;
              width: 100%;
              border: none;
              padding: 10px 20px;
              font-family: "Poppins", sans-serif;
              background-color: transparent;
              color: #101010ff;
              font-weight: bold;
              font-size: 1rem;
              &.active {
                background-color: ${({ theme }) => theme.color.blue};
                color: ${({ theme }) => theme.color.white};
              }
            }
          }
        }
      }
      #tab_content {
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
        margin-top: 20px;
        p {
          padding: 20px;
          width: 100%;
        }
      }
    }
  }
`;

export default AboutSection;
